import React from 'react';
import RangeSlider from '../RangeSlider';
import { conditionLabels } from '../../lib/constants';
import type { StepProps } from './types';

export default function BuildingConditionStep({ 
  formData, 
  handleSliderChange,
  handleInputChange 
}: StepProps) {
  return (
    <div className="space-y-6">
      <h3 className="text-lg font-medium text-gray-900 mb-4">État de l'immeuble</h3>
      <div className="space-y-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-3">
            État général
          </label>
          <RangeSlider
            value={parseInt(formData.etat_immeuble)}
            onChange={handleSliderChange('etat_immeuble')}
            labels={conditionLabels}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-3">
            État de la façade
          </label>
          <RangeSlider
            value={parseInt(formData.etat_facade)}
            onChange={handleSliderChange('etat_facade')}
            labels={conditionLabels}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-3">
            État des parties communes
          </label>
          <RangeSlider
            value={parseInt(formData.etat_partie_communes)}
            onChange={handleSliderChange('etat_partie_communes')}
            labels={conditionLabels}
          />
        </div>

        <div className="flex items-center mt-8">
          <input
            type="checkbox"
            id="showOptionalDetails"
            checked={formData.showOptionalDetails}
            onChange={(e) => handleInputChange({
              target: {
                name: 'showOptionalDetails',
                type: 'checkbox',
                checked: e.target.checked
              }
            } as React.ChangeEvent<HTMLInputElement>)}
            className="w-5 h-5 rounded border-gray-300 
              checked:bg-gradient-to-r checked:from-[#2A4365] checked:via-[#4A5568] checked:to-[#C4A052]
              focus:ring-[#2A4365] focus:ring-offset-2 transition-all duration-300"
          />
          <label htmlFor="showOptionalDetails" className="ml-3 text-sm text-gray-700">
            Plus de détails sur votre bien pour une estimation encore plus précise. (optionnel)
          </label>
        </div>
      </div>
    </div>
  );
}